import { render, staticRenderFns } from "./ProInput.vue?vue&type=template&id=69abbbe6&"
import script from "./ProInput.vue?vue&type=script&lang=js&"
export * from "./ProInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports